import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
export const TaskOrderStoreActionTypes = [
    ActionType.CreateTaskOrder,
    ActionType.FetchTaskOrder,
    ActionType.FetchTaskOrderSucceeded,
    ActionType.FetchTaskOrderFailed,
    ActionType.UpdateTaskOrder,
    ActionType.DeleteTaskOrder,
    ActionType.HydrateTaskOrders
];
